// Network.js
import config from './Config';

const getUrl = async (domain,shortcut) => {
    try{

        const res = await fetch(`${config.URL}/getUrl?domain=${domain}&shortcut=${shortcut}`);

        if(res.ok){
            return await res.json()
        }else{
            return null;
        }
    }catch(error){
        return null;
    }   

}

  export default {getUrl};

  